<template>
  <div id="app">
    <router-view v-if="IsRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      IsRouterAlive: true,
      usernickname: "",
    };
  },
  methods: {
    reload() {
      this.IsRouterAlive = false;
      this.$nextTick(function () {
        this.IsRouterAlive = true;
      });
    },
  },
  mounted() {
    if (localStorage.length < 3) {
      this.$router.push({ path: "/login" });
    }
  },
};
</script>

<style>
@import "../src/assets/css/common.css";
</style>




// WEBPACK FOOTER //
// src/App.vue